import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { hideToast } from '@/app/store/toastSlice';
import { usePopupTransition } from '@/shared/hooks/usePopupTransition';
import { IconCheckCircle } from '../icons';
import styles from './Toast.module.less';

const AUTO_HIDE_MS = 4000;

export function Toast() {
  const dispatch = useAppDispatch();
  const {
    visible: isOpen,
    message,
    variant,
  } = useAppSelector((state) => state.toast);

  const { visible, closing } = usePopupTransition(isOpen, 250);

  // Автоматически скрываем через 4 секунды
  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(() => dispatch(hideToast()), AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [isOpen]);

  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div
        className={`${styles.toast} ${closing ? styles.toastClosing : ''}`}
      >
        {variant === 'success' && <IconCheckCircle className={styles.icon} />}
        <span className={styles.message}>{message}</span>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={() => dispatch(hideToast())}
          aria-label="Закрыть"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
